import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=6eb8ab45&lang=pug&"
import script from "./EmptyList.vue?vue&type=script&lang=ts&"
export * from "./EmptyList.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=6eb8ab45&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports